import React, {useEffect, useMemo, useState, useRef} from "react";
import {Card, Button, CircularProgress, Hidden, Divider, Alert} from "@mui/material";
import Court from "../components/court";
import {Header} from "../components/header";

import {
    getAllMatchesByTouranamentIdandDate,
    getAllMatchesForTypeTwo,
    getBroadcastMessageByTournamentId,
    getDatesByTournamentId,
    getSponsorLogoByTournamentId,
    getTournamentIdByTournamentName,
    getTournamentTypeById,
} from "../network/lib/APIs";
import ScoreCard from "../components/scoreCard";
import {useParams} from "react-router-dom";
import {AnyCnameRecord} from "dns";
import {io} from "socket.io-client";
import Timeline from "../components/Timeline";
import NotificationBar from "../components/notificationbar";
import LogoBar from "../components/logoBar";
import {throttle} from 'lodash';
import { useBreakpoint } from "../utils/helpers";
import Ads from "../components/googleAds";
import PromoFooterBanner from "../components/PromoFooterBanner";
import MatchFeedWithPromo from "../components/MatchFeedWithPromo";
import { handleLearnMoreClick, handleStartForFreeClick, shouldShowDesktopPromo } from "../utils/promoLinkHandler";

interface Match {
    id: number;
    home_team: string;
    away_team: string;
    match_time: string;
}

function Tournaments() {
    const [data, setData] = useState<any>([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [defaultMatches, setDefaultMatches] = useState<any>([]);
    const [filteredCourtMatches, setFilteredCourtMatches] = useState<any>([]);
    const [filteredStatusMatches, setFilteredStatusMatches] = useState<any>([]);

    const {tournament_slug} = useParams();
    const [dateList, setDateList] = useState([]);
    const [tournamentType, setTournamentType] = useState("");
    const [transformedLiveMatchdata, setTransformedLiveMatchdata] = useState<any>(
        []
    );
    const [isloading, setIsLoading] = useState(false);
    const [tournamentId, setTournamentID] = useState();
    const [touranamentName, setTournamentName] = useState();
    const [selectedFilterBoxValue, setSelectedFilterBoxValue] = useState("");
    const [selectedEvent, setSelectedEvent] = useState("");
    const [isFilterClicked, setIsFilterClicked] = useState(false);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [tournamentTypeFetched, setTournamentTypeFetched] = useState(false);
    const [broadCastMessage, setbroadCastMessage] = useState("");
    const [organizationLogo, setOrganizationLogo] = useState("");
    const [sponsorLogo, setSponsorLogo] = useState("");
    const [liveScore, setLiveScore] = useState<any>([]);
    const [selectedStatus, setSelectedStatus] = useState("All");
    const [timelineDates, setTimelineDates] = useState<any>([]);
    const [initialDate, setInitialDate] = useState<any>();
    const [isAlertOpen, setIsAlertOpen] = useState(false);

    const [isConnected, setIsConnected] = useState(false);
    const breakpoint = useBreakpoint();
    const [showAdds , setShowAdds] = useState(false);
    const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);  
    const socket = useMemo(() => {
        const isProd = process.env.REACT_APP_STAGE === 'prod'; // or use a custom var like REACT_APP_ENV
        const baseUrl = isProd
            ? "https://livefeed1.scorebuzzer.com"
            : "https://livefeed1-qa.scorebuzzer.com";

        return io(baseUrl, {
            path: '/socket.io',
            transports: ["websocket"]
        });
    }, []); // prod: https://livefeed.scorebuzzer.com

    const throttledSetLiveScore = useMemo(
        () => throttle(setLiveScore, 300),
        []
    );

    // let tournament_id = tournamentId;
    // let date = selectedDate;
    // const tournament_name = tournament_slug;

    const firstDate = new Date(dateList[0]);
    const lastDate = new Date(dateList[dateList.length - 1]);
    const [tournamentStartDate, setTournamentStartDate] = useState(null);
    const [tournamentEndDate, setTournamentEndDate] = useState(null);
    const [dateRange, setDateRange] = useState('');
    const tournamentIdRef = useRef<number | undefined>(undefined);

    const optionsArray = data.map((item: any) =>
        item.info[0].teams ? item.info[0].teams : item.info[0].court
    );
    const teamsArray = data.map((item: any) => item.info[0].teams);


    useEffect(() => {
        fetchTournamentIdByTournamentName();
    }, [tournament_slug, selectedDate]);
    useEffect(() => {
        fetchDatesByTournamentId();
    }, [tournamentId]);
    useEffect(() => {
        fetchAllMatchesByTouranamentIdandDate();
    }, [tournamentId, selectedDate ,tournamentType]);

    useEffect(() => {
        // Update the ref whenever tournamentId changes
        tournamentIdRef.current = tournamentId;
    }, [tournamentId]);


    useEffect(() => {
        fetchTournamentTypeById();
    }, [tournamentId]);
    useEffect(() => {
        fetchSponsorLogoByTournamentId();
    }, [tournamentId]);
    useEffect(() => {
        fetchBroadcastMessageByTournamentId();
    }, [tournamentId]);

    useEffect(() => {
        const interval = setInterval(() => {
            //console.log("loading message...");
            fetchBroadcastMessageByTournamentId();
        }, 300000); // 5 minutes in milliseconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    // Track window resize for responsive promo banner
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const formattedFirstDate = tournamentStartDate ? formatDate(new Date(tournamentStartDate)) : "N/A";
        const formattedLastDate = tournamentEndDate ? formatDate(new Date(tournamentEndDate)) : "N/A";

        // const dateRange = `${formattedFirstDate} - ${formattedLastDate}`;
        setDateRange(`${formattedFirstDate} - ${formattedLastDate}`);
    }, [tournamentStartDate, tournamentEndDate]);


    const fetchTournamentIdByTournamentName = async () => {
        try {
            if (!tournament_slug) {
                throw new Error("Tournament name is undefined");
            }
            const response: any = await getTournamentIdByTournamentName(
                tournament_slug
            );
            setTournamentID(response.data.tournamentId);
            setTournamentName(response.data.tournamentName);
            //console.log("response:", response); // log the entire response object
            //console.log("tournament id response:", response.data); // log the tournament id
            // log the tournament id
        } catch (error) {
            console.error(error);
        }
    };
    const fetchDatesByTournamentId = async () => {
        try {
            if (tournamentId !== undefined) {
                const response: any = await getDatesByTournamentId(tournamentId);
                setDateList(response.data);
            }
        } catch (error) {
            //console.log(error);
        }
    };
    const fetchTournamentTypeById = async () => {
        try {
            if (tournamentId !== undefined) {
                const response: any = await getTournamentTypeById(tournamentId);
                setTournamentType(response.data.tournamentType);
                setShowAdds(response.data.showAds);
                setTournamentTypeFetched(true);
                setTournamentStartDate(response.data.startDate);
                setTournamentEndDate(response.data.endDate);
            }
        } catch (error) {
            //console.log(error);
        }
    };

    const fetchSponsorLogoByTournamentId = async () => {
        try {
            if (tournamentId !== undefined) {
                const response: any = await getSponsorLogoByTournamentId(tournamentId);
                setOrganizationLogo(response.data.TournamentLogoString);
                setSponsorLogo(response.data.SponsorLogoString);
            }
        } catch (error) {
            //console.log(error);
        }
    };

    const fetchBroadcastMessageByTournamentId = async () => {
        try {
            //console.log("tournament Id:" + tournamentIdRef.current);
            if (tournamentIdRef.current !== undefined) {
                const response: any = await getBroadcastMessageByTournamentId(
                    tournamentIdRef.current
                );
                setbroadCastMessage(response.data.Message);
            }
        } catch (error) {
            setbroadCastMessage("");
            //console.log(error);
        }
    };

    const sortByCourt = (mataches_data: any[]) => {
        return mataches_data.sort((a, b) => {
            if (a.info[0]?.court === "Not Allocated") return 1; // Move "Not Allocated" to end
            if (b.info[0]?.court === "Not Allocated") return -1;
            return a.info[0]?.court.localeCompare(b.info[0]?.court); // Alphabetical sorting
        });
    };
    const fetchAllMatchesByTouranamentIdandDate = async () => {
        try {
            //console.log("interval load " + tournamentIdRef.current);
            if (tournamentIdRef.current !== undefined) {
                // Convert the date into the desired format

                const formattedDate = new Date(selectedDate)
                    .toLocaleDateString("en-CA", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                    })
                    .replace(/\//g, "-");

                let response;
                //console.log("data type tournament type:" + typeof tournamentType);
                if (Number(tournamentType) === 2) {
                    response = await getAllMatchesForTypeTwo(
                        tournamentIdRef.current,
                        formattedDate
                    );
                }
                if (Number(tournamentType) === 1) {
                    response = await getAllMatchesByTouranamentIdandDate(
                        tournamentIdRef.current,
                        formattedDate
                    );
                }

                if (response && response.data) {
                    //console.log("Received data:", response.data);
                    let all_matches = Number(tournamentType) === 1 ? sortByCourt(response.data) : response.data;
                    setData(all_matches);
                    setDefaultMatches(all_matches);
                }

                if (selectedFilterBoxValue) {
                    setData(filteredCourtMatches);
                }
            }
        } catch (error) {
            console.error("GET MATCHES ERROR", error);
        }
    };


    const formatDate = (date: Date) => {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
            return "N/A";
        }
        // Use UTC methods to avoid timezone conversion issues
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = date.toLocaleString("en-US", {month: "short", timeZone: "UTC"});
        const year = date.getUTCFullYear();
        return `${day} ${month} ${year}`;
    };

    const getStatusText = (status: any) => {
        switch (status) {
            case 1:
                return "Scheduled";
            case 4:
                return "Completed";
            case 5:
                return "Suspended";
            case 6:
                return "Retired";
            case 3:
                return "In Progress";
            case 10:
                return "Interrupted";
            default:
                return "Unknown";
        }
    };
    const handleButtonClick = (status: any) => {
        setSelectedStatus(status);
    };
    const handleSelectInput = (e: any) => {
        // e.preventDefault();
        const selectedFilterBoxValue = e.target.innerText;
        setSelectedFilterBoxValue(selectedFilterBoxValue);
        setIsFilterClicked(true);
    };

    const handleEventInput = (e: any) => {
        setSelectedEvent(e.target.value);
    };


    const handleDateChange = (newValue: any) => {
        const selectedDate = newValue.target.value;
        const convertedDate = selectedDate.split("/").reverse().join("/");
        setInitialDate(newValue.target.value);
        setSelectedDate(convertedDate);
        setIsLoading(true);

        //console.log("Selected Date:", convertedDate);

        const filteredData = data.filter((item: any) => {
            return item.date === convertedDate;
        });

        //console.log("Filtered Data:", filteredData);

        setData(filteredData);
        setIsLoading(false);

        window.scrollTo({
            top: 10,
            behavior: "smooth",
        });
    };


    const handleShareClick = (matchuuid: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        const tournamentUrl = `${window.location.href}/matches/${matchuuid}`;
        navigator.clipboard
            .writeText(tournamentUrl)
            .then(() => {
                //console.log("URL copied to clipboard:", tournamentUrl);
                alert("Tournament URL copied to clipboard");
            })
            .catch((error) => {
                console.error("Failed to copy tournament URL: ", error);
            });
    };
    const filterMatchesByStatus = (matchesToFilter: any, status: any) => {
        return matchesToFilter
            .map((item: any) => ({
                ...item,
                info: item.info
                    .map((infoItem: any) => ({
                        ...infoItem,
                        cmatches: infoItem.cmatches.filter(
                            (cmatch: any) =>
                                cmatch.status === status ||
                                (status === "In Progress" &&
                                    (cmatch.status === "Scorecard" || cmatch.status === "scorecard"))
                        )

                    }))
                    .filter((infoItem: any) => infoItem.cmatches.length > 0),
            }))
            .filter((item: any) => item.info.length > 0);
    };

    const createHandleMatchesByStatus = (status: any) => () => {
        let matchesToFilter = selectedFilterBoxValue
            ? filteredCourtMatches
            : defaultMatches;

        const filteredMatches = filterMatchesByStatus(matchesToFilter, status);

        setData(filteredMatches);
        setFilteredStatusMatches(filteredMatches);
        setIsButtonClicked(true);
    };

    const handleScheduled = createHandleMatchesByStatus("Scheduled");
    const handleCompleted = createHandleMatchesByStatus("Completed");
    const handleLive = createHandleMatchesByStatus("In Progress");

    useEffect(() => {
        if (
            !selectedFilterBoxValue ||
            typeof selectedFilterBoxValue == "undefined"
        ) {
            if (
                selectedStatus == "Scheduled" ||
                selectedStatus == "In Progress" ||
                selectedStatus == "Completed"
            ) {
                let matchesToFilter = defaultMatches;
                const filteredMatches = filterMatchesByStatus(
                    matchesToFilter,
                    selectedStatus
                );

                setData(filteredMatches);
            } else if (selectedStatus == "All") {
                setData(defaultMatches);
            }
            return;
        }
        let matchesToFilter =
            selectedStatus == "Scheduled" ||
            selectedStatus == "In Progress" ||
            selectedStatus == "Completed"
                ? filteredStatusMatches
                : defaultMatches;

        // filter the data according to the selected court or teams
        const filteredData = matchesToFilter
            .map((item: any) => {
                const filteredInfo = item.info.filter((infoItem: any) => {
                    return (
                        (infoItem.teams &&
                            infoItem.teams.includes(selectedFilterBoxValue)) ||
                        infoItem.court === selectedFilterBoxValue
                    );
                });
                return {
                    ...item,
                    info: filteredInfo,
                };
            })
            .filter((item: any) => item.info.length > 0);

        setData(filteredData);
        setFilteredCourtMatches(filteredData);
    }, [selectedFilterBoxValue]);


    useEffect(() => {
        const transformedDates: any = dateList.map((date: any) => {
            const parts = date.split("/");
            const formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
            return formattedDate;
        });
        setTimelineDates(transformedDates);
    }, [dateList.length]);

    useEffect(() => {
        // get the most recent date
        const mostRecentDate = dateList[dateList.length - 1];
        // filter the data based on the most recent date
        const filteredData = data.filter((item: any) => {
            return item.date === mostRecentDate;
        });
        //console.log("mostRecentDate", mostRecentDate);
        // set the filtered data as the initial data
        setData(filteredData);
        setSelectedDate(mostRecentDate);
        window.scrollTo({
            top: 10,
            behavior: "smooth",
        });
    }, [dateList.length]);

    const loadIntialDate = async () => {
        setInitialDate(timelineDates[timelineDates.length - 1]);
    };

    useEffect(() => {
        loadIntialDate();
    }, [timelineDates]);
    // console.log("initialdate1", timelineDates[timelineDates.length - 1]);
    // console.log("initialdate2", timelineDates[timelineDates.length - 1]);
    // console.log("initialdate3", initialDate);

    useEffect(() => {
        if (
            isFilterClicked === false &&
            tournamentTypeFetched === true &&
            !selectedFilterBoxValue
        ) {
            fetchAllMatchesByTouranamentIdandDate();
        }
    }, []);

    useEffect(() => {
        setSelectedStatus("All");
    }, [selectedDate]);


    // function onScoreUpdate(score: any) {
    //     console.log("updating score:", score.score);
    //     setLiveScore(score.score);
    // }

    // // socket connection
    // useEffect(() => {
    //     // no-op if the socket is already connected
    //     if (socket && !socket.connected) {
    //         socket.connect();
    //     }
    //
    //     return () => {
    //         socket.disconnect();
    //     };
    // }, []);
    //
    // useEffect(() => {
    //
    //     console.log("tournamentId" + ": " + tournamentId);
    //
    //     if (tournamentId) {
    //
    //         //debug code
    //         console.log("did mount");
    //         console.log("socket details", socket);
    //
    //         //console.log('tournament_channel_19:App\\Events\\ScoreUpdate');
    //         // socket.on("connect", () => {
    //         //     console.log("socket connected", socket.connected); // true
    //         // });
    //
    //         socket.on("connect_error", (err: any) => {
    //             //socket.auth.token = "abcd";
    //             console.log(`connection error ${err.message}`);
    //             // some additional description, for example the status code of the initial HTTP response
    //             console.log(err.description);
    //
    //             // some additional context, for example the XMLHttpRequest object
    //             console.log(err.context);
    //         });
    //
    //
    //         //https://testorg-qa.scorebuzzer.com/demo-tennis-tournament-2017
    //         //dynamic based on the tournament id
    //         // socket.on(`tournament_channel_${tournamentId}`+ ':ScoreUpdate', onScoreUpdate);
    //         //const eventName_1 = `tournament_channel_${tournamentId}:App\\\\Events\\\\ScoreUpdateNew` as string;
    //         const eventName = `tournament_channel_${tournamentId}:App\\Events\\ScoreUpdateNew` as string;
    //         //console.log("event: " + eventName_1 + " " + eventName_2);
    //         socket.on(eventName, onScoreUpdate);
    //
    //
    //         socket.on("disconnect", () => {
    //             console.warn("Socket disconnected");
    //         });
    //
    //         return () => {
    //             console.log("Cleaning up socket...");
    //             //socket.disconnect();
    //             //socket.off(`tournament_channel_${tournamentId}`+ ':ScoreUpdate', onScoreUpdate);
    //             socket.off(eventName, onScoreUpdate);
    //         };
    //     }
    // }, [tournamentId]);

    // Connection management


    useEffect(() => {
        const onConnect = () => setIsConnected(true);
        const onDisconnect = () => setIsConnected(false);

        socket.on('connect', onConnect);
        socket.on('disconnect', onDisconnect);

        return () => {
            socket.off('connect', onConnect);
            socket.off('disconnect', onDisconnect);
        };
    }, [socket]);

// Connect/disconnect based on tournamentId
    useEffect(() => {
        if (tournamentId) {
            socket.connect();
        }

        return () => {
            if (isConnected) {
                socket.disconnect();
            }
        };
    }, [tournamentId, socket, isConnected]);

// Score updates
    useEffect(() => {
        function onScoreUpdate(score: any) {
            try {
                //console.log("updating score:", score.score);
                throttledSetLiveScore(score.score);
                setDefaultMatches((prevMatches: any) => {
                    return prevMatches.map((item: any) => ({
                        ...item,
                        info: item.info.map((infoItem: any) => ({
                            ...infoItem,
                            cmatches: infoItem.cmatches.map((cmatch: any) => {
                                if (cmatch.matchId === score.score.matchId) {
                                    return {
                                        ...cmatch,
                                        score: score.score,
                                        status: getStatusText(score.score.status)
                                    };
                                }
                                return cmatch;
                            })
                        }))
                    }));
                });
            } catch (error) {
                console.error("Error processing score update:", error);
            }
        }

        const onConnectError = (err: any) => {
            console.error(`Connection error: ${err.message}`);
        };

        if (tournamentId) {
            //console.log("tournamentId detected");

            const eventName = `tournament_channel_${tournamentId}:App\\Events\\ScoreUpdateNew`;

            socket.on(eventName, onScoreUpdate);
            socket.on("connect_error", onConnectError);

            return () => {
                socket.off(eventName, onScoreUpdate);
                socket.off("connect_error", onConnectError);
            };
        }
        //console.log("tournamentId, socket, throttledSetLiveScore update");
    }, [tournamentId, socket, throttledSetLiveScore]);

    useEffect(() => {
        let matchesToFilter = defaultMatches;

        if (selectedStatus !== "All") {
            matchesToFilter = filterMatchesByStatus(matchesToFilter, selectedStatus);
        }

        if (selectedFilterBoxValue) {
            matchesToFilter = matchesToFilter
                .map((item: any) => {
                    const filteredInfo = item.info.filter((infoItem: any) => {
                        return (
                            (infoItem.teams &&
                                infoItem.teams.includes(selectedFilterBoxValue)) ||
                            infoItem.court === selectedFilterBoxValue
                        );
                    });
                    return {
                        ...item,
                        info: filteredInfo,
                    };
                })
                .filter((item: any) => item.info.length > 0);
        }

        setData(matchesToFilter);
    }, [defaultMatches, selectedStatus, selectedFilterBoxValue]);


    useEffect(() => {
        try {

            if (liveScore) {
                const transformedData = {
                    matchId: liveScore?.matchId,
                    status: getStatusText(liveScore?.status),
                    score: {
                        duration: liveScore?.duration,
                        timeZone: liveScore?.timeZone,
                        team1: {
                            setsWon: liveScore?.team1?.score?.setsWon,
                            sets: liveScore?.team1?.score?.sets?.map((set: any) => ({
                                setScore: set?.setScore ?? null,
                                tieBreakScore: set?.tieBreakScore ?? null,
                            })) ?? [],
                            gameScore: liveScore?.team1?.score?.gameScore,
                            isCurrentServer: liveScore?.team1?.players[0]?.isServer || liveScore?.team1?.players[1]?.isServer,
                            isWinner: false,
                        },
                        team2: {
                            setsWon: liveScore?.team2?.score?.setsWon,
                            sets: liveScore?.team2?.score?.sets?.map((set: any) => ({
                                setScore: set?.setScore ?? null,
                                tieBreakScore: set?.tieBreakScore ?? null,
                            })) ?? [],
                            gameScore: liveScore?.team2?.score?.gameScore,
                            isCurrentServer: liveScore?.team2?.players[0]?.isServer || liveScore?.team2?.players[1]?.isServer,
                            isWinner: false,
                        },
                        serveEvent: liveScore?.matchInfo,
                        // serveEvent: liveScore?.serveEvent?.events
                        //     ?.filter((event: any) => event?.event && event.event !== "firstserve")
                        //     ?.map((event: any) => String(event.event))[0] || null,
                    },
                };
                setTransformedLiveMatchdata(transformedData);
            }

        } catch (error) {
           // console.log("useEffect error", error);
        }
    }, [liveScore]);

    //const parsedInitialDate = initialDate.split('/').reverse().join('-');
    const showDesktopBanner = shouldShowDesktopPromo(windowWidth, ['lg', 'xl'].includes(breakpoint));

    return (
        <>
            <div
                className={`flex flex-col md:flex-row mb-0 w-full ${showDesktopBanner ? 'page-with-promo-banner' : ''}`}
                style={{backgroundColor: "#E6E6EF", margin: 0, padding: 0}}
            >
                <div className="w-full">
                    <Header
                        selectedEvent={selectedEvent}
                        handleEventInput={handleEventInput}
                        handleSelectInput={handleSelectInput}
                        // key ={filteredCourtMatches}
                        // handleFilter={fetchMatchesByCourtAndDate}
                        title={
                            (data.length && data[0].info && data[0].info[0].teams
                                ? "Teams"
                                : "") ||
                            (data.length && data[0].info && data[0].info[0].court
                                ? "Court"
                                : "")
                        }
                        handleScheduled={handleScheduled}
                        handleCompleted={handleCompleted}
                        handleLive={handleLive}
                        handleAll={fetchAllMatchesByTouranamentIdandDate}
                        selectedStatus={selectedStatus}
                        handleButtonClick={handleButtonClick}
                        autoCompleteData={optionsArray}
                        touranamentName={touranamentName}
                        dateRange={dateRange}
                        Completed="Completed"
                        Scheduled="Scheduled"
                        Live="In Progress"
                        All="All"
                    />
                </div>
                {/* <div className="my-3">
            <Ads />
         </div> */}
                <div className="mx-2 my-0 md:my-0 md:w-6/6 ml-16  md:ml-0">
                    <div
                        className="my-0 md:my-2 flex  justify-center  "
                        style={{marginLeft: "-50px"}}
                    >
                        <Timeline
                            dateList={timelineDates}
                            handleDateChange={handleDateChange}
                            selectedDate={initialDate}
                        />
                    </div>
                </div>
            </div>
            {broadCastMessage && <div className="my-2 mx-2">
                {" "}
                <NotificationBar message={broadCastMessage}/>
            </div>}
            <LogoBar
                organizationLogoUrl={organizationLogo}
                sponsorLogoUrl={sponsorLogo}
            />
            {/* {isAlertOpen && (
                    <Alert
                      severity="success"
                    >
                     Tournament URL copied to clipboard
                    </Alert>
                  )} */}
            {isloading ? (
                <div
                    className="ml-1/2"
                    style={{
                        top: 200,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <CircularProgress color="primary"/>
                </div>
            ) : (
                <div className={`grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 m-2 ${showDesktopBanner ? 'pb-32' : ''}`}>
                    <>
                        <MatchFeedWithPromo
                            data={data}
                            transformedLiveMatchdata={transformedLiveMatchdata}
                            handleShareClick={handleShareClick}
                            isAlertOpen={isAlertOpen}
                            onLearnMore={handleLearnMoreClick}
                            onStartForFree={handleStartForFreeClick}
                            breakpoint={breakpoint}
                        />

                        {data?.map((item: any, index: any) => {
                            const enableAddRow =
                                index === data.length - 1 ||
                                (breakpoint === 'xs') ||
                                (breakpoint === 'sm' && (index + 1) % 2 === 0) ||
                                (breakpoint === 'md' && (index + 1) % 3 === 0) ||
                                (['lg', 'xl'].includes(breakpoint) && (index + 1) % 4 === 0);
                            return (
                                <React.Fragment key={index}>
                                    {showAdds && (
                                        enableAddRow && (
                                            <div className="col-span-full my-2">
                                                <Ads
                                                    adClient="ca-pub-5865015491816611"
                                                    adSlot="2630465909"
                                                    style={{ display: 'block', margin: '20px 0' }}
                                                />
                                            </div>
                                        )
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </>
                </div>
            )}

            {/* Desktop footer banner - shown only on multi-column layouts */}
            {showDesktopBanner && (
                <PromoFooterBanner
                    onLearnMore={handleLearnMoreClick}
                    onStartForFree={handleStartForFreeClick}
                />
            )}
        </>
    );
}

export default Tournaments;
